import { draftSpan, type PlanningDraftState } from '../../../features/disposition-planning';
import type { MinuteRange } from '../../../shared/lib/schedule';
import type { BoardBlock } from './boardTypes';

/**
 * What the one drag primitive is currently holding: an existing block, or the planning draft.
 *
 * `useBlockDrag` only reads `key` and `span`; the rest rides along so `handleCommit` can branch
 * without a lookup. A block commit becomes a `PATCH /schedule`; a draft commit is a pure state
 * update — the draft is not on the server yet.
 */

/** The draft's key on the board. Never collides with a block key (`APPOINTMENT:42`, `BREAK:p3`). */
export const DRAFT_KEY = '__planning-draft__';

export type DragSubject =
  | { type: 'block'; key: string; span: MinuteRange; block: BoardBlock }
  | { type: 'draft'; key: typeof DRAFT_KEY; span: MinuteRange; draft: PlanningDraftState };

export const blockSubject = (block: BoardBlock): DragSubject => ({
  type: 'block',
  key: block.key,
  span: block.span,
  block,
});

export const draftSubject = (draft: PlanningDraftState): DragSubject => ({
  type: 'draft',
  key: DRAFT_KEY,
  span: draftSpan(draft),
  draft,
});
